<div>
    <form [formGroup]="historiasUsuarioGroup" autocomplete="off">
    <div class="row">
        <div class="col-sm-12">
            <mat-form-field>
                <mat-label>T&iacute;tulo:</mat-label>
                <textarea aria-label="Título:" formControlName='tituloCtrl' maxlength="100" matInput placeholder="Título:"
                    [(ngModel)]="objetoHistoriaUsuario.nombre"></textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <mat-form-field>
                <mat-label>Descripci&oacute;n:</mat-label>
                <textarea aria-label="Descripción:" formControlName='descripcionCtrl' maxlength="300" matInput placeholder="Descripción"
                    [(ngModel)]="objetoHistoriaUsuario.descripcion"></textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-4">
            <mat-form-field>
                <mat-label>Como:</mat-label>
                <textarea aria-label="Como:" formControlName='comoCtrl' maxlength="100" matInput placeholder="Como"
                    [(ngModel)]="objetoHistoriaUsuario.como"></textarea>
            </mat-form-field>
        </div>
        <div class="col-sm-8">
            <mat-form-field>
                <mat-label>Necesito:</mat-label>
                <textarea aria-label="Necesito:" maxlength="200" matInput placeholder="Necesito" [(ngModel)]="objetoHistoriaUsuario.necesito"
                    formControlName='necesitoCtrl'></textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <mat-form-field>
                <mat-label>Para:</mat-label>
                <textarea aria-label="Para:" formControlName='paraCtrl' maxlength="200" matInput placeholder="Para" 
                    [(ngModel)]="objetoHistoriaUsuario.para"></textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <mat-form-field>
                <mat-label>Criterios de aceptaci&oacute;n:</mat-label>
                <textarea aria-label="Criterios de aceptación:" formControlName='criteriosAceptacionCtrl' maxlength="500" matInput placeholder="Criterios de aceptación" rows="8" cols="80"
                    [(ngModel)]="objetoHistoriaUsuario.criterios_aceptacion"></textarea>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-3">
            <mat-form-field>
                <mat-label>Iteraci&oacute;n</mat-label>
                <mat-select formControlName='iteracionCtrl' placeholder="Iteración" required [(ngModel)]="objetoHistoriaUsuario.iteracion">
                    <mat-option *ngFor="let prob of iteracion" [value]="prob.valor">
                        {{ prob.valor }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field>
                <mat-label>Prioridad</mat-label>
                <mat-select formControlName='prioridadCtrl' placeholder="Prioridad" required [(ngModel)]="objetoHistoriaUsuario.prioridad">
                    <mat-option *ngFor="let prob of prioridad" [value]="prob.valor">
                        {{ prob.valor }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field>
                <mat-label>Riesgo</mat-label>
                <mat-select formControlName='riesgoCtrl' placeholder="Riesgo" required [(ngModel)]="objetoHistoriaUsuario.riesgo">
                    <mat-option *ngFor="let prob of riesgo" [value]="prob.valor">
                        {{ prob.nombre }} ({{ prob.valor }})
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field>
                <mat-label>Puntos</mat-label>
                <input aria-label="Puntos" maxlength="2" matInput placeholder="Puntos:" soloNumero
                formControlName='puntosCtrl' [(ngModel)]="objetoHistoriaUsuario.puntos">
            </mat-form-field>
        </div>
        <div class="col-sm-12">
            <mat-form-field>
                <mat-label>Asignar &Eacute;pica</mat-label>
                <mat-select formControlName='epicaCtrl' placeholder="Asignar Épica" required [(ngModel)]="objetoHistoriaUsuario.idEpica">
                    <mat-option *ngFor="let epicas of listEpicas" [value]="epicas.id">
                        {{epicas.nombre}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <button mat-button class="btn  btn-success" (click)="guardarHu()" [disabled]="historiasUsuarioGroup.invalid">
                Guardar <i class='material-icons'> save </i>
            </button>
        </div>
    </div>
</form>
</div>